import {
  decryptE2eeFileWithFileKey,
  guessMimeFromFilename,
  importRsaPrivateJwk,
  unwrapFileKeyForRecipient,
} from '@common/e2ee/e2ee-crypto';
import {getRsaPrivateJwk} from '@common/e2ee/e2ee-session';

export interface ReceiveFileDelivery {
  id: number;
  name: string;
  delivery_mode?: 'plain' | 'e2ee';
  e2ee_iv?: string | null;
  e2ee_wrapped_key?: string | null;
}

export async function downloadReceiveFile(
  file: ReceiveFileDelivery,
  downloadUrl: string,
): Promise<void> {
  if (file.delivery_mode !== 'e2ee' || !file.e2ee_iv || !file.e2ee_wrapped_key) {
    triggerBrowserDownload(downloadUrl, file.name);
    return;
  }

  const rsaPrivateJwk = getRsaPrivateJwk();
  if (!rsaPrivateJwk) {
    triggerBrowserDownload(downloadUrl, file.name);
    return;
  }

  const ciphertext = await fetch(downloadUrl, {credentials: 'include'}).then(r => {
    if (!r.ok) {
      throw new Error('Download failed.');
    }
    return r.arrayBuffer();
  });

  const privateKey = await importRsaPrivateJwk(rsaPrivateJwk);
  const fileKey = await unwrapFileKeyForRecipient(
    file.e2ee_wrapped_key,
    privateKey,
  );
  const plain = await decryptE2eeFileWithFileKey(
    ciphertext,
    fileKey,
    file.e2ee_iv,
  );
  const mime = guessMimeFromFilename(file.name);
  const blob = new Blob([plain], {type: mime});
  const objectUrl = URL.createObjectURL(blob);
  triggerBrowserDownload(objectUrl, file.name);
  URL.revokeObjectURL(objectUrl);
}

function triggerBrowserDownload(url: string, filename: string): void {
  const anchor = document.createElement('a');
  anchor.href = url;
  anchor.download = filename;
  anchor.rel = 'noopener';
  document.body.appendChild(anchor);
  anchor.click();
  anchor.remove();
}
